import { createSlice, createSelector } from "@reduxjs/toolkit";
import { NodeHealthStatus } from "../commonTypes";
const initialState = {
    selectedNodeId: null,
    filters: {
        status: "all",
        search: ""
    }
};
const nodesSlice = createSlice({
    name: "nodes",
    initialState,
    reducers: {
        setSelectedNode (state, action) {
            state.selectedNodeId = action.payload;
        },
        setNodeFilters (state, action) {
            state.filters = {
                ...state.filters,
                ...action.payload
            };
        }
    }
});
export const { setSelectedNode, setNodeFilters } = nodesSlice.actions;
// Selectors
const selectFilters = (state)=>state.nodes.filters;
const selectNodes = (_, nodes)=>nodes;
export const selectFilteredNodes = createSelector([
    selectFilters,
    selectNodes
], (filters, nodes)=>{
    const { search, status } = filters;
    const filtered = nodes.filter((node)=>{
        const currentStatus = node.healthStatus;
        const matchesSearch = node.nodeId.toLowerCase().includes(search.toLowerCase()) || node.description.toLowerCase().includes(search.toLowerCase()) || node.location.toLowerCase().includes(search.toLowerCase());
        const matchesStatus = status === "all" || currentStatus === status;
        return matchesSearch && matchesStatus;
    });
    // Sort by status priority: Error -> Offline -> Healthy
    const statusPriority = {
        [NodeHealthStatus.Error]: 0,
        [NodeHealthStatus.Offline]: 1,
        [NodeHealthStatus.Healthy]: 2
    };
    return filtered.sort((a, b)=>{
        const priorityA = statusPriority[a.healthStatus];
        const priorityB = statusPriority[b.healthStatus];
        if (priorityA !== priorityB) {
            return priorityA - priorityB;
        }
        // Secondary sort by ID for stability
        return a.nodeId.localeCompare(b.nodeId);
    });
});
export const selectNodeStats = createSelector([
    selectNodes
], (nodes)=>{
    return {
        totalNodes: nodes.length,
        healthy: nodes.filter((n)=>n.healthStatus === NodeHealthStatus.Healthy).length,
        error: nodes.filter((n)=>n.healthStatus === NodeHealthStatus.Error).length,
        offline: nodes.filter((n)=>n.healthStatus === NodeHealthStatus.Offline).length
    };
});
export default nodesSlice.reducer;
